import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Grid, Col, Row } from '../utils/bootstrap';

class Footer extends React.Component {
  render() {
    return (
      <footer>
        <Grid className="info">
          <Row>
            <Col xs={12} sm={5} md={6} lg={4} lgOffset={1}>
              <img src="/PCP-white.png" alt="Premium Capital" style={{marginBottom: '2em'}} />
            </Col>
            <Col xs={6} sm={3} md={3} lg={3}>
              <h4>Our Office</h4>
              <p>
                {`5.01, Level 5, Menara MBMR,
                No.1, Jalan Syed Putra,
                58000 Kuala Lumpur,
                Malaysia`}
              </p>
            </Col>
            <Col xs={6} sm={4} md={3} lg={3}>
              <h4>Contact</h4>
              <p>
                {`T: +603 27 100 123
                F: +603 27 100 122
                E: care@premiumcapital.com.my`}
              </p>

            </Col>
          </Row>
        </Grid>
        <div className="links">
          <p style={{ textAlign: 'center', marginBottom: 0, paddingBottom: '3em' }}>
            <Link to="/privacy-policy">Privacy Policy</Link> | <u>Terms and Conditions</u> | <Link to="/disclaimer">Disclaimer</Link><br />
            {new Date().getFullYear()} © Premium Capital Partners Sdn. Bhd.
          </p>
        </div>
      </footer>
    );
  }
}

export default withRouter(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js